var _circle, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9995,
    cy: 18.9995,
    r: 18.9995,
    fill: "url(#paint0_linear_6834_107)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 9.5,
    width: 3,
    height: 13,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 25.5,
    width: 3,
    height: 3,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6834_107",
    x1: 0,
    y1: 0,
    x2: 37.9991,
    y2: 37.9991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlert);
export default __webpack_public_path__ + "static/media/error-alert.cb0e29de0331b2f6329ea0dbf624e842.svg";
export { ForwardRef as ReactComponent };